export default __webpack_public_path__ + "static/media/discipline-natural-sciences.7c2a1de3.svg";